import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../lib/auth";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Pricing() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const onSubscribe = async () => {
    if (!user) { nav("/login"); return; }
    setBusy(true); setErr(null);
    try {
      const r = await axios.post(`${API}/billing/checkout`, {}, { withCredentials: true });
      if (r.data?.checkout_url) window.location.href = r.data.checkout_url;
      else setErr("No checkout URL returned");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Checkout failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 px-4 py-12" data-testid="pricing-page">
      <div className="max-w-3xl mx-auto text-center">
        <div className="text-[10px] uppercase font-mono text-zinc-500 mb-2">HCRIS+ by LiquidSMARTS</div>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900">Simple pricing</h1>
        <p className="mt-3 text-zinc-600">One paid tier. Cancel anytime.</p>
      </div>
      <div className="mt-10 max-w-md mx-auto bg-white border-2 border-emerald-600 rounded-xl p-8 shadow-sm">
        <div className="text-[10px] uppercase font-mono text-emerald-700 tracking-wider">Pro</div>
        <div className="mt-2 text-4xl font-semibold text-zinc-900">
          $99<span className="text-base font-normal text-zinc-500">/mo</span>
        </div>
        <ul className="mt-6 space-y-2 text-sm text-zinc-700">
          <li>• Unlimited LLM-generated reports</li>
          <li>• Citation-first, hallucination-detected narratives</li>
          <li>• Create shareable scorecard + report links</li>
          <li>• Download scorecard PDFs</li>
          <li>• Peer benchmarks + composite quality grade</li>
        </ul>
        <button onClick={onSubscribe} disabled={busy}
                className="mt-6 w-full px-4 py-2 rounded bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50 text-white text-sm font-mono uppercase tracking-wider"
                data-testid="pricing-get-pro-btn">
          {busy ? "Redirecting…" : (user ? "Get Pro" : "Sign in to subscribe")}
        </button>
        {err && <div className="mt-3 text-xs text-red-700 font-mono">{err}</div>}
        <div className="mt-4 text-[11px] text-zinc-500 font-mono">
          Test mode · use card 4242 4242 4242 4242 + any future exp + any CVC.
        </div>
      </div>
      <div className="mt-8 text-center text-xs text-zinc-500">
        Free tier: read all hospital + system data, view your own reports.
        <Link to="/" className="ml-2 underline">Back to search</Link>
      </div>
    </div>
  );
}
